import React, {
  createContext,
  useContext,
  useState,
  useEffect
} from "react";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {

  // =========================
  // INIT CART (SAFE LOAD)
  // =========================
  const [cart, setCart] = useState(() => {
    try {
      const saved = localStorage.getItem("cart");
      return saved ? JSON.parse(saved) : [];
    } catch (err) {
      console.error("Cart parse error:", err);
      return [];
    }
  });

  // =========================
  // SAVE CART
  // =========================
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  // =========================
  // GET ID
  // =========================
  const getId = (p) => p?.id || p?.Id;

  // =========================
  // ADD TO CART
  // =========================
  const addToCart = (product) => {

  const id = getId(product);

  if (!id) {
    console.error("PRODUCT ID MISSING", product);
    return;
  }

  setCart((prev) => {

    const exist = prev.find(
      (p) => getId(p) === id
    );

    const newQty =
      Number(product.qty || 1);

    if (exist) {

      return prev.map((p) =>
        getId(p) === id
          ? {
              ...p,
              qty:
                Number(p.qty || 0) +
                newQty
            }
          : p
      );
    }

    return [
      ...prev,
      {
        ...product,
        id,
        qty: newQty
      }
    ];
  });
};

  // =========================
  // REMOVE FROM CART
  // =========================
  const removeFromCart = (id) => {
    setCart((prev) =>
      prev.filter((p) => getId(p) !== id)
    );
  };

  // =========================
  // UPDATE QTY
  // =========================
  const updateQty = (id, qty) => {

    if (qty < 1) {
      removeFromCart(id);
      return;
    }

    setCart((prev) =>
      prev.map((p) =>
        getId(p) === id
          ? { ...p, qty }
          : p
      )
    );
  };

  // =========================
  // CLEAR CART
  // =========================
  const clearCart = () => {
    setCart([]);
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        updateQty,
        clearCart
      }}
    >
      {children}
    </CartContext.Provider>
  );
};